import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

// import { FaChevronRight } from 'react-icons/fa';

import './Rate.css';

import BarsLoadingIndicator from '../common/barsLoadingIndicator/BarsLoadingIndicator';
import { getMiniBookingWidgetData } from '../../features/MiniBookingWidget/MiniBookingWidgetSlice';
import { isZeroNumber } from 'lib';

const Rate = ({
    price,
    text,
    rateType,
    currencySymbol,
    className,
    onClick,
    icon,
    link,
    url,
}) => {
    // There is no need to keep local state as the component will rerender
    // after the global state changes
    const isPriceAvailable =
        typeof price === 'string' && !price.startsWith('getprice');
    const loading = !isPriceAvailable;
    const dispatch = useDispatch();

    useEffect(() => {
        if (typeof price === 'string' && price.startsWith('getprice')) {
            dispatch(getMiniBookingWidgetData());
        }
        // return () => {
        //     cleanup
        // }
    }, [price]);

    if (!price || isZeroNumber(price)) {
        return null;
    }

    return (
        price && (
            <div
                className={`ab-desktop-widget-rate ${className} ab-small-rate-section`}
                onClick={link ? () => {} : onClick}
            >
                {link ? (
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ab-desktop-widget-rate--link"
                    >
                        <div className="ab-desktop-widget-rate-text-left ab-desktop-widget-rate-price-cnt">
                            <div className="ab-desktop-widget-rate-text">
                                {text}
                            </div>
                            {icon && (
                                <span className="ab-desktop-widget-rate-icon">
                                    {icon}
                                </span>
                            )}
                            {/* <div className="ab-desktop-widget-rate-wrapper">
                                <div className="ab-desktop-widget-rate-price-cnt ab-small-widget-rate">
                                    <div className="ab-desktop-widget-rate-left">
                                        <span className="ab-desktop-widget-rate-type">
                                            {rateType}
                                        </span>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="ab-desktop-widget-rate-text-right ab-desktop-widget-rate-right">
                            {loading ? (
                                <BarsLoadingIndicator classes="ab-bars-loading-indicator--light-gray" />
                            ) : (
                                <span className="ab-desktop-widget-rate-price">
                                    {`${currencySymbol} ${price}`}
                                </span>
                            )}
                            {/* <span className="ab-icon">
                                <FaChevronRight size={14} />
                            </span> */}
                        </div>
                    </a>
                ) : (
                    <>
                        <div className="ab-desktop-widget-rate-text-left ab-desktop-widget-rate-price-cnt">
                            <div className="ab-desktop-widget-rate-text">
                                {text}
                            </div>
                            {icon && (
                                <span className="ab-desktop-widget-rate-icon">
                                    {icon}
                                </span>
                            )}
                            {/* <div className="ab-desktop-widget-rate-wrapper">
                                <div className="ab-desktop-widget-rate-price-cnt ab-small-widget-rate">
                                    <div className="ab-desktop-widget-rate-left">
                                        <span className="ab-desktop-widget-rate-type">
                                            {rateType}
                                        </span>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="ab-desktop-widget-rate-text-right ab-desktop-widget-rate-right">
                            {loading ? (
                                <BarsLoadingIndicator classes="ab-bars-loading-indicator--light-gray" />
                            ) : (
                                <span className="ab-desktop-widget-rate-price">
                                    {`${currencySymbol} ${price}`}
                                </span>
                            )}
                            {/* <span className="ab-icon">
                                <FaChevronRight size={14} />
                            </span> */}
                        </div>
                    </>
                )}
            </div>
        )
    );
};

Rate.propTypes = {
    price: PropTypes.string,
    text: PropTypes.string,
    rateType: PropTypes.string,
    currencySymbol: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    link: PropTypes.bool,
    url: PropTypes.string,
};

Rate.defaultProps = {
    className: '',
};

export default Rate;
